export const realtorPaths = {
  OFFER: '/offer',
  FLAT: '/flat',
  BOOKING: '/booking',
  DETAILED_BOOKING: '/booking/:id',
  COMPANY_REALTOR: '/company-realtor',
  DETAILED_COMPANY_REALTOR: '/company-realtor/:id'
};
